export const schar = "​";
